// extracted by mini-css-extract-plugin
module.exports = {"wakeSysBlue":"#4a90e2","smallScreenMaxWidth":"767px","smallScreenMinWidth":"768px"};